export default "__VITE_PUBLIC_ASSET__5a48962d__"